import { WorkspacePermissionValues } from '#state'
import { CHANGE_TRACKING_HELP_URL, PAGE_LOCKING_HELP_URL } from '#util'

export type PermissionConfig = {
  code: string
  title: string
  description: string
  helpLink?: string
  enabled?: boolean
}

export const CHANGE_SCRIPT_STATUS_CONFIG: PermissionConfig = {
  code: WorkspacePermissionValues.CHANGE_SCRIPT_STATUS,
  title: 'Script Access',
  description: 'Manage who is allowed to mark scripts as Limited or Open.',
  helpLink:
    'https://help.scripto.live/en/articles/5489227-script-access-levels-limited-access-scripts',
}

export const MODIFY_LIMITED_SCRIPT_CONFIG: PermissionConfig = {
  code: WorkspacePermissionValues.MODIFY_LIMITED_SCRIPT,
  title: 'Limited Access Editing',
  description: 'Manage who is allowed to edit Limited Access scripts.',
  helpLink:
    'https://help.scripto.live/en/articles/5489227-script-access-levels-limited-access-scripts',
}

export const PUSH_TO_PROMPTER_CONFIG: PermissionConfig = {
  code: WorkspacePermissionValues.PUSH_TO_PROMPTER,
  title: 'Push to Prompter',
  description: 'Manage who is allowed to push scripts to the teleprompter.',
  helpLink:
    'https://help.scripto.live/en/articles/5160170-using-the-push-to-prompter-feature',
}

export const UPDATE_RUNDOWNS_CONFIG: PermissionConfig = {
  code: WorkspacePermissionValues.UPDATE_RUNDOWNS,
  title: 'Rundowns',
  description: 'Manage who is allowed to edit rundowns.',
  helpLink:
    'https://help.scripto.live/en/articles/8229784-getting-started-with-rundowns',
}

export const DESTROY_CONTENT_CONFIG: PermissionConfig = {
  code: WorkspacePermissionValues.DESTROY_CONTENT,
  title: 'Delete content',
  description:
    'Manage who is allowed to permanently delete shared scripts from the trash.',
}

export const ENABLE_CHANGE_TRACKING_CONFIG: PermissionConfig = {
  code: 'ENABLE_CHANGE_TRACKING',
  title: 'Enable change-tracking mode',
  description: 'Manage who is allowed to enable change-tracking mode.',
  helpLink: CHANGE_TRACKING_HELP_URL,
}

export const REVIEW_TRACKED_CHANGES_CONFIG: PermissionConfig = {
  code: 'REVIEW_TRACKED_CHANGES',
  title: 'Approve and decline tracked changes',
  description:
    'Manage who is allowed to approve and decline changes made during change-tracking sessions.',
  helpLink: CHANGE_TRACKING_HELP_URL,
}

export const PAGE_LOCKER_CONFIG: PermissionConfig = {
  code: 'PAGE_LOCKER',
  title: 'Locked pages',
  description: 'Manage who is allowed to lock and unlock script pages.',
  helpLink: PAGE_LOCKING_HELP_URL,
}

export const MANAGE_REVISIONS_CONFIG: PermissionConfig = {
  code: WorkspacePermissionValues.MANAGE_REVISIONS,
  title: 'Manage Revisions',
  description:
    'Manage who is allowed to create, edit, and manage script revisions.',
}

const PRODUCTION_GROUP = 'Production'
const SCRIPT_EDITING_AND_ACCESS_GROUP = 'Script Editing and Access'

export const GROUPED_PERMISSIONS: Record<string, string[]> = {
  [PRODUCTION_GROUP]: [
    MANAGE_REVISIONS_CONFIG.code,
    PAGE_LOCKER_CONFIG.code,
    PUSH_TO_PROMPTER_CONFIG.code,
    UPDATE_RUNDOWNS_CONFIG.code,
  ],
  [SCRIPT_EDITING_AND_ACCESS_GROUP]: [
    CHANGE_SCRIPT_STATUS_CONFIG.code,
    MODIFY_LIMITED_SCRIPT_CONFIG.code,
    ENABLE_CHANGE_TRACKING_CONFIG.code,
    REVIEW_TRACKED_CHANGES_CONFIG.code,
    DESTROY_CONTENT_CONFIG.code,
  ],
}
